import React, { useEffect, useState } from "react";
import "./styles.scss";
import { FormHeader, MenusCard } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewMenu } from "../CreateNewItem";
import { getAllMenus } from "../CreateNewItem/CreateNewMenu/service/menus.service";
import { useDispatch, useSelector } from "react-redux";
import { setMenu, setMenuList } from "./redux/actions";
import { getLanguage } from "../../utils/environment";

const lan = getLanguage();

const Menus = () => {
  const dispatch = useDispatch();
  // const [menusList, setMenusList] = useState([]);
  const menusList = useSelector((state) => state.menuReducer.menuList);
  const categoryList = useSelector(
    (state) => state.categoryReducer.categoryList
  );
  const [selectMenu, setSelectMenu] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getMenus = await getAllMenus();

        console.log("Get All Menus : ", getMenus);

        if (getMenus?.data) {
          dispatch(setMenuList(getMenus.data));
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Menus", error);
      }
    };
    fetchData();
  }, []);

  const fetchCategoryName = (categoryId) => {
    const category = categoryList?.find(
      (category) => category.category_id === categoryId
    );
    return category ? category.name[lan] : "-";
  };

  return (
    <>
      <div className="hne-menus-wrapper">
        <div className="col-9 menus-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Menus",
              size: "md-md",
            }}
          />
          <div className="hne-menus-header-wrapper">
            <div className="mhw-id">Id</div>
            {lan === "si" && <div className="mhw-si">name - (SI)</div>}
            <div className="mhw-si">name - (EN)</div>
            <div className="mhw-category">Category name</div>
            <div className="mhw-status">Status</div>
          </div>
          <div className="hne-menus-body-wrapper">
            {Array.isArray(menusList) && menusList.length > 0 ? (
              menusList.map((menus) => (
                <MenusCard
                  isSelect={selectMenu === menus?.menu_id}
                  id={menus.menu_id}
                  nameSI={menus.menu_name.si}
                  nameEN={menus.menu_name.en}
                  category={fetchCategoryName(menus.category)}
                  status={menus.status}
                  edit="Edit"
                  onClick={() => {
                    setSelectMenu(menus?.menu_id);
                    dispatch(setMenu(menus));
                  }}
                />
              ))
            ) : (
              <div className="error-message">No Menus Found</div>
            )}
          </div>
        </div>

        {/*right side*/}
        <div className="col-3 menus-right-side-wrapper">
          <CreateNewMenu />
        </div>
      </div>
    </>
  );
};
export default withRouter(Menus);
